document.addEventListener("DOMContentLoaded", function () {
  const loadContainer = document.querySelector("[data-load-search]");
  if (!loadContainer) return;
  const resultsContainer = loadContainer.querySelector(
    "[data-load-search-results]"
  );
  const counterContainer = document.querySelector("[data-load-search-counter]");

  function updateCounter(count) {
    if (counterContainer) {
      const counterText = counterContainer.dataset.loadSearchCounterText;
      counterContainer.innerHTML = `<div class="span">${count} ${counterText}</div>`;
    }

    document.title = document.title.replace(/\d+\s+results?\s+found/i, `${count} result${count === 1 ? '' : 's'} found`);
  }

  function noResults() {
    resultsContainer.innerHTML =
      '<div class="predictive-search__loading">No articles found in AYMES Academy</div>';
  }

  function showResults() {
    // resultsContainer.classList.add('predictive-search__results--visible');
  }

  function showLoading() {
    resultsContainer.innerHTML =
      '<div class="predictive-search__loading">Searching...</div>';
    showResults();
  }

  async function performSearch(query) {
    showLoading();

    const controller = new AbortController();
    currentRequest = controller;

    try {
      const response = await fetch(
        `https://aymes-academy.onrender.com/articles/${encodeURIComponent(
          query
        )}`
      );

      if (!response.ok) throw new Error("Search failed");

      const data = await response.json();
      // console.log('Search API Response:', data);

      const articles = (data || []).filter(article => article.published_at !== null);

      displayResults(articles);
      updateCounter(articles.length);
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error("Search error:", error);
        updateCounter(0);
        noResults();
      }
    }
  }

  function displayResults(articles) {
    if (articles.length === 0) {
      noResults();
      updateCounter(0);
      return;
    }

    const gridItems = articles
      .map((article) => {
        // console.log('Article object:', article);
        // console.log('Available fields:', Object.keys(article));

        return returnHtml(article);
      })
      .join("");

    resultsContainer.innerHTML = `
    <div class="blog-articles-grid">
      ${gridItems}
    </div>
    `;

    showResults();
  }

  function calculateReadTime(content) {
    // Strip HTML and count words (matching Liquid logic)
    const textContent = content.replace(/<[^>]*>/g, "");
    const words = textContent.split(" ").filter((word) => word.length > 0);
    const totalWords = words.length;

    // Use same reading speed as Liquid: 270 WPM = 4.5 words per second
    const wordsPerSecond = 270.0 / 60.0;
    const readTimeSeconds = totalWords / wordsPerSecond;
    const readTimeMinutes = readTimeSeconds / 60.0;

    // Round up (Math.ceil matches Liquid's ceil filter)
    const totalReadTime = Math.ceil(readTimeMinutes);

    return `${totalReadTime} min read`;
  }

  function returnHtml(article) {
    const url = `/blogs/aymes-academy/${article.handle}`;
    // TODO: @lucas Check if you can use the comments_count from the article object. If not, don't worry about it.

    const readTime = calculateReadTime(
      article.body_html || article.content || ""
    );

    // TODO: Review comments_count
    return `
      <div class="article-card article-card--transparent">
        <a href="${url}" class="article-card__link">
          <div class="article-card__image">
            ${
              article.image
                ? `<img src="${article.image.src}" alt="${article.title}" width="400" height="300" loading="lazy">`
                : `<img src="/assets/article-placeholder.jpg" alt="${article.title}" width="400" height="300" loading="lazy">`
            }
          </div>
          <div class="article-card__content">
            <div class="article-card__meta">
              <div class="article-card__pills">
                <span class="article-card__pill">${readTime}</span>
                <span class="article-card__pill" style="display: none;">${
                  article.comments_count !== undefined && article.comments_count > 0 && article.comments_count !== 'false'
                } comment${article.comments_count !== 1 ? "s" : ""}</span>
              </div>
            </div>
            <h3 class="article-card__title">${article.title}</h3>
            <p class="article-card__excerpt">
              ${
                article.excerpt ||
                article.summary_html
                  ?.replace(/<[^>]*>/g, "")
                  .substring(0, 120) ||
                article.body_html?.replace(/<[^>]*>/g, "").substring(0, 120) ||
                ""
              }
            </p>
          </div>
        </a>
      </div>
    `;
  }

  function initSearch() {
    const searchTerms = loadContainer.dataset.searchTerms;
    console.log("Initial search terms:", searchTerms);
    if (searchTerms && searchTerms.trim()) {
      performSearch(searchTerms);
    } else {
      noResults();
    }
  }

  // Hide results when clicking outside
  initSearch();
});

class AcademySearchForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector("form");
    this.input = this.querySelector("input");

    this.form.addEventListener("submit", (e) => {
      e.preventDefault();
      this.performSearch(e, this.input.value);
    });
  }

  performSearch(event, query) {
    event.preventDefault();

    // Go to the search page with the query
    window.location.href = `/search?q=${encodeURIComponent(query)}&type=article&view=academy`;
  }
}

customElements.define("academy-search-form", AcademySearchForm);